import { broadcastLogout } from "./auth-sync";

/**
 * Custom fetch wrapper that handles authentication errors globally
 * Automatically redirects to login on 401 errors.
 *
 * 401 and 403 both still throw, so callers halt either way. Only 401 clears the
 * session and redirects: a 403 means authenticated but not permitted, and
 * logging that user out was signing Viewers out of the app the moment they
 * opened a chat.
 */
export async function apiFetch(
  url: string,
  options?: RequestInit
): Promise<Response> {
  try {
    const response = await fetch(url, options);

    if (response.status === 401 || response.status === 403) {
      if (response.status === 401) {
        console.warn("Session expired (401). Redirecting to login...");
        sessionStorage.clear();
        broadcastLogout();
        window.location.href = "/login";
      } else {
        console.warn(`Forbidden (403) for ${url}. Not a session problem.`);
      }

      // Throw either way to prevent further processing: many callers do not
      // check response.ok, and would otherwise parse the error body as data.
      const error: any = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      throw error;
    }

    return response;
  } catch (error: any) {
    // Re-throw the error for the caller to handle
    throw error;
  }
}
